import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h1 style={styles.title}>Terms of Service</h1>
      </div>

      <div style={styles.content}>
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Acceptance of Terms</h2>
          <p style={styles.text}>
            By accessing and using this VPN service, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>2. Service Provider</h2>
          <p style={styles.text}>
            This Service is operated by an independent developer based in Washington State, USA. The Service is provided on an "as-is" basis for personal use.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>3. Acceptable Use</h2>
          <p style={styles.text}>
            You agree to use the Service only for lawful purposes. Prohibited activities include but are not limited to:
          </p>
          <ul style={styles.list}>
            <li>Illegal activities or violations of any applicable laws</li>
            <li>Hacking, attacking, or disrupting networks or systems</li>
            <li>Distributing malware, viruses, or harmful code</li>
            <li>Spamming or sending unsolicited communications</li>
            <li>Infringing on intellectual property rights</li>
            <li>Sharing or reselling your account access</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Account Registration</h2>
          <p style={styles.text}>
            To use the Service, you must:
          </p>
          <ul style={styles.list}>
            <li>Provide accurate and complete registration information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Be at least 18 years of age</li>
            <li>Notify us immediately of any unauthorized account access</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Service Plans and Payments</h2>
          <p style={styles.text}>
            The Service offers various subscription plans with different data quotas and validity periods. All payments are processed through third-party payment providers. Refunds are handled on a case-by-case basis.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Service Availability</h2>
          <p style={styles.text}>
            While we strive to provide reliable service, we do not guarantee:
          </p>
          <ul style={styles.list}>
            <li>Uninterrupted or error-free service</li>
            <li>Specific connection speeds or performance</li>
            <li>Availability in all geographic locations</li>
            <li>Compatibility with all devices or networks</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Data Usage and Quotas</h2>
          <p style={styles.text}>
            Each subscription plan includes a specific data quota. Once your quota is exhausted or your subscription expires, service access will be suspended until renewal.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Termination</h2>
          <p style={styles.text}>
            We reserve the right to suspend or terminate your account at any time for:
          </p>
          <ul style={styles.list}>
            <li>Violation of these Terms of Service</li>
            <li>Fraudulent or abusive behavior</li>
            <li>Non-payment of fees</li>
            <li>Any reason at our sole discretion</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>9. Limitation of Liability</h2>
          <p style={styles.text}>
            To the maximum extent permitted by law, the Service provider shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service. Our total liability shall not exceed the amount you paid for the Service in the past 12 months.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>10. Disclaimer of Warranties</h2>
          <p style={styles.text}>
            The Service is provided "as is" without warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>11. Indemnification</h2>
          <p style={styles.text}>
            You agree to indemnify and hold harmless the Service provider from any claims, damages, or expenses arising from your use of the Service or violation of these Terms.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>12. Governing Law</h2>
          <p style={styles.text}>
            These Terms shall be governed by and construed in accordance with the laws of Washington State, USA, without regard to its conflict of law provisions.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>13. Changes to Terms</h2>
          <p style={styles.text}>
            We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting. Your continued use of the Service constitutes acceptance of the modified Terms.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>14. Contact Information</h2>
          <p style={styles.text}>
            For questions or concerns about these Terms, please contact:<br />
            Email: douxingma@zohomail.com<br />
            Website: douxingma.com<br />
            Location: Washington State, USA
          </p>
        </section>

        <p style={styles.updateTime}>Last Updated: April 23, 2026</p>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    background: '#f5f7fa',
    padding: '20px'
  },
  header: {
    maxWidth: '800px',
    margin: '0 auto 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
  },
  backBtn: {
    padding: '10px 20px',
    background: '#fff',
    border: '1px solid #e8e8e8',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#666'
  },
  title: {
    margin: 0,
    color: '#333',
    fontSize: '28px',
    fontWeight: 'bold'
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    background: '#fff',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
  },
  section: {
    marginBottom: '32px'
  },
  sectionTitle: {
    color: '#333',
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '16px'
  },
  text: {
    color: '#666',
    fontSize: '15px',
    lineHeight: '1.8',
    margin: '0 0 12px 0'
  },
  list: {
    color: '#666',
    fontSize: '15px',
    lineHeight: '1.8',
    paddingLeft: '24px'
  },
  updateTime: {
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: '1px solid #f0f0f0',
    color: '#999',
    fontSize: '14px',
    textAlign: 'center'
  }
};
